/*
 * @Description: 本月参与项目
 * @Date: 2020-10-14 15:58:13
 * @LastEditors: wjx
 */

import { agentManager } from '@/api/ajax';
import fields from './fields';
import search from './search';
import TableRenderClass from '@/components/tableRender/tableRenderClass';
import AddProject from '../child/add-project.vue';

let add = {
  name: '添加项目',
  render(h, ctx) {
    const table = ctx.parent.$parent;
    const addProject = () => {
      table.$xrkDialog({
        title: '添加项目',
        width: '650px',
        showCancel: false,
        showConfirm: false,
        $slots: {
          default: table.$createElement(AddProject, {
            props: {
              userId: table.defaultQuery.userId
            },
            on: {
              confirm() {
                table.$xrkDialog.remove();
                table.saveSuccess();
              }
            }
          })
        }
      });
    };
    return (
      <el-button
        style="margin-bottom: 10px"
        icon="el-icon-plus"
        type="primary"
        disabled={table.defaultQuery._status === 2}
        onClick={addProject}
      >
        添加项目
      </el-button>
    );
  }
  // fn(app, table) {

  // }
};

let example = new TableRenderClass({ fields, search });

let part = example.createPart({
  name: '本月参与项目',
  list: agentManager.projectInfoJoinedCurrentMonth,
  requestNow: true,
  fields: ['index', 'projectName', 'status', 'taskSum', 'finishSum', 'record'],
  moreBtnArr: [add]
});

export default { name: '项目详情', childMenu: [part] };
